import classNames from 'classnames'
import _ from 'lodash'
import React, {useContext} from 'react'
import {LayoutContext} from '../../../../components/layouts/Default/LayoutContext'
import {NullAsDefault, renderIf, renderMail, renderPhone,} from 'views/Shared'
import {IdentifierTypes} from "../../../AppLocals/appFieldTypes";
import {Avatar, message, Popconfirm, Tag, Tooltip} from "antd";
import {FaAddressCard, FaUserGraduate} from "react-icons/fa6";
import {renderIfElse} from "../../../Shared";
import getTitle from "../../../../helpers/getTitle";
import copyToClipboard from "copy-to-clipboard";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {IoCheckmarkCircle, IoCopyOutline, IoEllipseOutline} from "react-icons/io5";
import {StudentActionTypes} from "../../../AppLocals/Course";
import getAliasName from "../../../../helpers/getAliasName";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {GoDotFill} from "react-icons/go";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import ImageLoader from "../../../../components/ImageLoader";
import {BsChevronRight, BsEyeFill, BsPeopleFill} from "react-icons/bs";
import {HiHashtag, HiPhone} from "react-icons/hi2";
import {PiArrowsClockwiseBold, PiGenderFemaleBold, PiGenderMaleBold, PiLinkSimpleBold} from "react-icons/pi";
import {MdMerge, MdOutlineEmail} from "react-icons/md";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {studentLink_rotateSecretCode_Api, studentLink_sendInvite_Api} from "../../../../apis";
import {EstimatedDobTag} from "../../../../components/common/EstimatedDobTag";
import {getGroupColor} from "./renderCourseClassStudent";
import {HiOutlineMail} from "react-icons/hi";
import {RiShieldCheckFill} from "react-icons/ri";
import {IDENTITY_STATUS} from "../../../AppLocals/Course/Student/components/StudentIdentitySection";

const STUDENT_STATUS_ARCHIVED = 9

// 2 chữ cái đầu+cuối tên (khớp mockup "HN"/"XN") - khác getNameInitial (renderCourseClassStudent.js,
// CHỈ 1 chữ) nên viết riêng, không đổi helper dùng chung đang có chỗ khác phụ thuộc.
export const getInitials = (fullname) => {
    if (!fullname) return '?'
    const words = fullname.trim().split(/\s+/)
    const first = words[0]?.charAt(0) || ''
    const last = words.length > 1 ? words[words.length - 1]?.charAt(0) || '' : ''
    return (first + last).toUpperCase() || '?'
}

// Badge giới tính chuẩn (♂ xanh / ♀ hồng) - export để Giáo viên / Phụ huynh / Đơn đăng ký dùng
// chung 1 thiết kế. Trả null nếu giới tính không xác định.
export const renderGenderBadge = (gender, t) => {
    if (gender !== 1 && gender !== 2) return null
    return (
        <span className={classNames(
            "px-2 py-0.5 w-fit rounded-full text-2xs font-bold flex items-center gap-1 flex-shrink-0 whitespace-no-wrap",
            gender === 1 ? "bg-blue-50 text-blue-600" : "bg-pink-50 text-pink-600"
        )}>
            {gender === 1 ? <PiGenderMaleBold size={11} /> : <PiGenderFemaleBold size={11} />} {t(getLabelOfGender(gender))}
        </span>
    )
}

const LinkSecretCodeCell = ({studentId, initialCode, t}) => {
    const [code, setCode] = React.useState(initialCode)
    const {isLoading, handleAsyncAction: rotateCode} = useAsyncAction({
        apiInfo: studentLink_rotateSecretCode_Api,
        onSuccess: (_, meta) => {
            const newCode = meta?.response?.data?.link_secret_code
            if (newCode) {
                setCode(newCode)
                message.success(t('link code rotated'))
            }
        },
        onError: () => message.error(t('failed to rotate code')),
    })

    if (!code) return null

    return (
        <div className="flex items-center gap-1">
            <PiLinkSimpleBold size={11} className="text-indigo-400 flex-shrink-0"/>
            <span className="text-color-400">{`${t('link code')}: `}</span>
            <span
                onClick={() => {
                    copyToClipboard(code);
                    message.info(t('copied'))
                }}
                className="font-mono font-bold text-indigo-600 tracking-widest cursor-pointer hover:text-indigo-800 flex items-center gap-1">
                {code}
                <IoCopyOutline size={10}/>
            </span>
            <button
                disabled={isLoading}
                onClick={() => rotateCode({}, {id: studentId})}
                className="ml-1 flex items-center gap-1 text-color-400 hover:text-indigo-600 transition-colors disabled:opacity-40">
                <PiArrowsClockwiseBold size={12} className={isLoading ? 'animate-spin' : ''}/>
            </button>
        </div>
    )
}

// Nút "Gửi email mời liên kết" - CHỈ hiện khi BE báo can_send_link_invite=true (nguồn duy nhất:
// Student::canSendLinkInvite() - contact_email hợp lệ, học viên CHƯA có StudentUserLink active nào,
// chưa vượt rate-limit invite_max_count lần/ngày (cấu hình server, xem invite_max_count bên dưới).
// KHÔNG còn bắt buộc contact_email phải khớp tài khoản Kristo Network có sẵn - BE tự chọn nội dung
// email mời đăng nhập/mời đăng ký phù hợp). Gửi xong tự ẩn nút NGAY tại
// chỗ (không đợi refetch cả danh sách) - can_send_link_invite thật của item cha vẫn cũ cho tới lần
// load lại kế tiếp, nên dùng state `sent` cục bộ để không cho bấm gửi lặp lại trong phiên này.
// iconOnly - dòng riêng của nút này trong bảng (renderStudentTableRow) hẹp lại đáng kể trên
// mobile, chữ "Gửi email mời liên kết" tràn/đẩy lệch hàng - bạn báo. Rút về nút tròn cùng kích
// thước (28px) với 2 nút mắt/bánh răng bên cạnh cho đồng bộ, giữ text qua thuộc tính title (hover).
//
// inviteSentCount/inviteMaxCount - BE trả sẵn (StudentTransformer(Basic)::invite_sent_count/
// invite_max_count, invite_max_count đọc từ Student::getLinkInviteMaxCount() - cấu hình
// STUDENT_LINK_INVITE_MAX_COUNT trên server, KHÔNG hardcode ở FE) - hiện số lần đã gửi/tối đa để
// admin biết còn gửi được bao nhiêu lần trước khi bị chặn (chống spam/khai thác). Sau khi gửi
// thành công, đọc lại đúng 2 field này từ response (không tự +1 ở FE) để không lệch nếu BE tính
// khác đi.
const SendLinkInviteButton = ({studentId, canSend, t, compact = false, iconOnly = false, inviteSentCount = 0, inviteMaxCount = 3}) => {
    const [sent, setSent] = React.useState(false)
    const [sentCount, setSentCount] = React.useState(inviteSentCount)
    const [maxCount, setMaxCount] = React.useState(inviteMaxCount)
    const {isLoading, handleAsyncAction: sendInvite} = useAsyncAction({
        apiInfo: studentLink_sendInvite_Api,
        onSuccess: (_, meta) => {
            setSent(true)
            const data = meta?.response?.data
            if (typeof data?.invite_sent_count === 'number') setSentCount(data.invite_sent_count)
            if (typeof data?.invite_max_count === 'number') setMaxCount(data.invite_max_count)
            message.success(t('link invite sent'))
        },
        onError: () => message.error(t('failed to send link invite')),
    })

    const countLabel = sentCount > 0 ? t('link invite sent count', {count: sentCount, max: maxCount}) : null

    if (sent) {
        return iconOnly ? (
            <span
                title={countLabel ? `${t('invite sent')} · ${countLabel}` : t('invite sent')}
                style={{width: 28, height: 28}}
                className="flex flex-center rounded-full bg-green-50 text-green-600 flex-shrink-0">
                <IoCheckmarkCircle size={13}/>
            </span>
        ) : (
            <div className="flex flex-col items-end gap-0.5">
                <span className="px-2 py-1 rounded-full bg-green-50 text-green-600 font-semibold text-2xs flex items-center gap-1 whitespace-no-wrap">
                    <IoCheckmarkCircle size={11}/>
                    {t('invite sent')}
                </span>
                {countLabel && (
                    <span className="text-2xs text-color-300 whitespace-no-wrap">{countLabel}</span>
                )}
            </div>
        )
    }

    // Trước đây return null im lặng khi !canSend, KHÔNG phân biệt được "đã liên kết rồi" (hiện
    // @username riêng ở Codes row) với "đã gửi nhưng đang bị chặn tạm" (đạt invite_max_count hoặc
    // trong 24h rate-limit của Student::canSendLinkInvite()) - bạn báo nhầm tưởng học viên tự động bị
    // liên kết vì không thấy nút mà cũng không thấy lý do. Còn sentCount > 0 (đã từng gửi) mà giờ
    // !canSend thì CHẮC CHẮN là do rate-limit/đạt giới hạn (nếu do đã liên kết thì @username đã hiện
    // ở chỗ khác rồi, không liên quan tới field này) - hiện lại đúng lý do thay vì im lặng.
    if (!canSend) {
        if (sentCount <= 0) return null
        return iconOnly ? (
            <span
                title={countLabel}
                style={{width: 28, height: 28}}
                className="flex flex-center rounded-full background-100 text-color-300 flex-shrink-0">
                <HiOutlineMail size={13}/>
            </span>
        ) : (
            <span className="text-2xs text-color-300 italic whitespace-no-wrap">{countLabel}</span>
        )
    }

    return (
        <div className="flex flex-col items-end gap-0.5">
            <Popconfirm
                title={t('send link invite confirm title')}
                description={t('send link invite confirm description')}
                onConfirm={() => sendInvite({}, {id: studentId})}
                okText={t('send')}
                cancelText={t('cancel')}>
                {iconOnly ? (
                    <button
                        type="button"
                        disabled={isLoading}
                        title={countLabel ? `${t('send link invite')} · ${countLabel}` : t('send link invite')}
                        style={{width: 28, height: 28}}
                        className="flex flex-center flex-shrink-0 rounded-full border border-blue-200 bg-blue-50 hover:bg-blue-100 text-blue-600 disabled:opacity-50">
                        <HiOutlineMail size={13}/>
                    </button>
                ) : (
                    <button
                        type="button"
                        disabled={isLoading}
                        className={classNames(
                            "flex items-center gap-1 rounded-full bg-blue-50 hover:bg-blue-100 text-blue-600 font-semibold whitespace-no-wrap disabled:opacity-50",
                            compact ? "px-2 py-1 text-2xs" : "px-2.5 py-1 text-xs"
                        )}>
                        <HiOutlineMail size={compact ? 11 : 12}/>
                        {t('send link invite')}
                    </button>
                )}
            </Popconfirm>
            {countLabel && !iconOnly && (
                <span className="text-2xs text-color-300 whitespace-no-wrap">{countLabel}</span>
            )}
        </div>
    )
}

export const renderStudent = ({translate: t, isLg, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        edit, avatar,
        user, fullname, gender,
        date_of_birth, date_of_birth_is_estimated, place_of_birth,
        contact_phone, contact_email, contact_address,
        student_idcode, ref_id, identifier_code, identifier_type,
        link_secret_code,
        medal_awards = [],
        religious_order, religious_order_name,
        patron_saint_name,
        father, mother,
        status, merged_into_id,
        course_class,
    } = item ?? {}

    const isArchived = status === STUDENT_STATUS_ARCHIVED

    const inactive = item?.active === 0

    // BE lưu NULL thật khi học viên chưa có ngày sinh (không bịa giá trị giả) - chỉ cần check rỗng.
    const isUnknownDob = !date_of_birth

    const hasFather = father?.name || father?.user?.name
    const hasMother = mother?.name || mother?.user?.name
    const fatherName = father?.user?.name || father?.name
    const fatherPhone = father?.phone
    const motherName = mother?.user?.name || mother?.name
    const motherPhone = mother?.phone

    return (
        <div key={index} className={classNames(
            "px-4 py-3 flex gap-3 custom-item-render relative list-item hover:background-100 transition-colors",
            isArchived && "opacity-60 bg-gray-50"
        )}>
            {/* Avatar */}
            {renderIfElse(
                avatar,
                <Avatar
                    size={38}
                    className={classNames("flex-shrink-0 mt-0.5 flex flex-center background-200", inactive && 'opacity-40')}
                    src={avatar}
                    icon={<FaUserGraduate size={18} className="text-color-500"/>}
                />,
                <Avatar
                    size={38}
                    src={user?.avatar}
                    icon={<FaUserGraduate size={18} className="text-color-500"/>}
                    className={classNames("flex-shrink-0 mt-0.5 flex flex-center background-200", inactive && 'opacity-40')}
                />
            )}

            {/* Main content */}
            <div className="flex flex-col flex-1 relative">

                {/* Student core info */}
                <div className={classNames("flex flex-col flex-1 min-w-0 pr-4", inactive && 'opacity-40')}>
                    {/* Name */}
                    <h2
                        onClick={() => handleAction(StudentActionTypes.STUDENT_DETAIL, item)}
                        className="flex items-baseline gap-1 font-bold text-base text-color-000 hover:text-primary cursor-pointer leading-snug">
                        {getAliasName(item, 'patron_saint') && (
                            <span className="font-medium text-sm text-slate-600">
                                {getAliasName(item, 'patron_saint')}
                            </span>
                        )}
                        <span className="truncate">{fullname}</span>
                    </h2>

                    {isArchived && (
                        <div className="flex items-center gap-1.5 mt-0.5">
                            <Tag
                                icon={<MdMerge size={11} className="inline mr-0.5"/>}
                                color="default"
                                className="text-xs font-medium text-gray-500 border-gray-300">
                                {t('archived')}
                            </Tag>
                            {merged_into_id && (
                                <span className="text-xs text-color-400 italic">{t('merged into another record')}</span>
                            )}
                        </div>
                    )}

                    {/* Codes row */}
                    <div className="flex items-center gap-x-3 gap-y-1 flex-wrap mt-0.5">
                        {student_idcode && (
                            <div className="flex items-center gap-1 tracking-wide">
                                {!isLg ? <HiHashtag size={11} className="text-color-400"/> : <span className="text-color-400">{`${t('student code')}: `}</span>}
                                <span
                                    onClick={() => {
                                        copyToClipboard(student_idcode)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer flex items-center gap-1">
                                    {student_idcode}
                                    <IoCopyOutline size={10}/>
                                </span>
                            </div>
                        )}
                        {ref_id && (
                            <div className="flex items-center gap-1 tracking-wide">
                                {!isLg ? <HiHashtag size={11} className="text-color-400"/> : <span className="text-color-400">{`${t('Ref')}: `}</span>}
                                <span
                                    onClick={() => {
                                        copyToClipboard(ref_id)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-secondary-500 hover:text-secondary-600 cursor-pointer flex items-center gap-1">
                                    {ref_id}
                                    <IoCopyOutline size={10}/>
                                </span>
                            </div>
                        )}
                        {(edit === true && identifier_code) && (
                            <div className="flex items-center gap-1 tracking-wide">
                                {!isLg
                                    ? <FaAddressCard size={11} className="text-color-400"/>
                                    : <span className="text-color-400">{`${t(_.find(IdentifierTypes, {value: identifier_type})?.label)}: `}</span>
                                }
                                <span
                                    onClick={() => {
                                        copyToClipboard(identifier_code)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer flex items-center gap-1">
                                    {identifier_code}
                                    <IoCopyOutline size={10}/>
                                </span>
                            </div>
                        )}
                        {edit === true && link_secret_code !== undefined && (
                            <LinkSecretCodeCell
                                studentId={item?.id}
                                initialCode={link_secret_code}
                                t={t}
                            />
                        )}
                    </div>

                    {/* Class */}
                    {course_class && (
                        <span className="mt-0.5 space-x-1 tracking-wider">
                            <span className="font-normal text-color-400">{`${t('class')}: `}</span>
                            <span className="font-medium text-slate-600">{course_class?.title}</span>
                            <span className="font-normal text-color-400">{t('belong to course').toLowerCase()}</span>
                            <span className="font-medium text-color-000">{course_class?.course?.title}</span>
                        </span>
                    )}
                </div>

                <div className={classNames("mt-2 flex flex-1 flex-col md:flex-row gap-2 md:gap-3 min-w-0", inactive && 'opacity-40')}>
                    {/* More information */}
                    <div className="flex flex-col flex-1 gap-0.5">
                        {/* Details compact row */}
                        <div className="flex items-center gap-x-3 gap-y-1 flex-wrap text-color-400 italic">
                            {!isUnknownDob && (
                                <span className="space-x-1">
                                    <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                    <span>{t('date of birth')} :</span>
                                    <span className="text-color-200 font-medium not-italic">
                                        {formatDate(date_of_birth, 'DD/MM/YYYY')}
                                    </span>
                                    {date_of_birth_is_estimated && <EstimatedDobTag/>}
                                </span>
                            )}
                            {gender !== 0 && (
                                <span className="space-x-1">
                                <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                <span className="text-color-200 font-medium not-italic">{t(getLabelOfGender(gender))}</span>
                            </span>
                            )}
                            {contact_phone && (
                                <span className="space-x-1 font-medium text-color-200 tracking-wider">
                                    <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                    {renderPhone(contact_phone)}
                                </span>
                            )}
                            {contact_email && (
                                <span className="space-x-1 font-medium text-color-200 tracking-wider">
                                    <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                    {renderMail(contact_email)}
                                </span>
                            )}
                        </div>

                        {contact_address && (
                            <span className="space-x-1 text-color-200 italic tracking-wider">
                                <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                <span className="text-color-400">{`${t('address')}: `}</span>
                                <span className="font-medium">{contact_address}</span>
                            </span>
                        )}

                        {/* Religious order */}
                        {religious_order_name && (
                            <div className="space-x-1 text-color-400 italic">
                                <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                <span>{t('belong to religious order')} :</span>
                                <Link
                                    to={getLinkToDetail(religious_order)}
                                    className="font-medium text-slate-600 hover:text-blue-700 no-underline">
                                    {religious_order_name}
                                </Link>
                            </div>
                        )}

                        {/* Medals */}
                        {medal_awards?.length > 0 && (
                            <div className="flex items-center gap-1 flex-wrap">
                                <GoDotFill size={10} className="text-color-500 flex-shrink-0"/>
                                <span className="text-xs text-color-400 italic">{`${t('certification awarded')} :`}</span>
                                {medal_awards.map((e, i) => (
                                    <div key={i} className="flex items-center gap-1">
                                        <span className="font-medium text-xs text-secondary-600 italic">{getTitle(e.medal)}</span>
                                        {renderIf(
                                            e?.medal?.avatar,
                                            <ImageLoader src={e?.medal?.avatar} style={{width: 24, height: 20}}/>
                                        )}
                                        {i < medal_awards.length - 1 && <span className="text-color-300">,</span>}
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                    {/* Parent info - right column on desktop */}
                    {isLg && (hasFather || hasMother) && (
                        <div className="pl-3 flex flex-col gap-1 md:border-l border-color-100 text-xs">
                            <div className="flex items-center gap-1 mb-0.5">
                                <BsPeopleFill size={12} className="text-slate-500"/>
                                <span className="font-bold text-2xs text-slate-400 uppercase tracking-wide whitespace-no-wrap">
                                    {t('parent information')}
                                </span>
                            </div>
                            {fatherName && (
                                <div className="space-x-1">
                                    <span className="text-color-400 italic whitespace-no-wrap flex-shrink-0">{t('father')} :</span>
                                    <span className="space-x-1 font-medium not-italic">
                                        <span className="text-color-200">{fatherName}</span>
                                        {fatherPhone && (
                                            <span className="text-slate-500">
                                                - {fatherPhone}
                                            </span>
                                        )}
                                    </span>
                                </div>
                            )}
                            {motherName && (
                                <div className="space-x-1">
                                    <span className="text-color-400 italic whitespace-no-wrap flex-shrink-0">{t('mother')} :</span>
                                    <span className="space-x-1 font-medium not-italic">
                                        <span className="text-color-200 font-medium not-italic">{motherName}</span>
                                        {motherPhone && (
                                            <span className="text-slate-500">
                                                - {motherPhone}
                                            </span>
                                        )}
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {(inactive) && (
                    <div className="mt-1 flex justify-end">
                        <span className="px-3 py-0.5 border border-orange-300 rounded-full font-medium text-xs md:text-2xs text-orange-400">
                            {t('temporarily inactive')}
                        </span>
                    </div>
                )}
            </div>

            {/* Context menu */}
            <div className="absolute right-8 top-8 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

// Layout "Thẻ" (mặc định mobile) + "Bảng" (mặc định desktop) cho trang Quản lý Học viên
// (Students.js) - theo đúng 2 mockup bạn gửi, KHÔNG đổi renderStudent gốc phía trên (Teachers.js
// vẫn đang dùng nguyên bản đó cho màn hình khác). Rút gọn field so với renderStudent gốc (bỏ địa
// chỉ/dòng tôn giáo/huy hiệu/phụ huynh) đúng theo những gì mockup thể hiện - các field đầy đủ vẫn
// xem được qua "Chi tiết" (StudentActionTypes.STUDENT_DETAIL, mở StudentViewCard đầy đủ tab).
export const renderStudentCardItem = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        avatar,
        fullname, gender,
        date_of_birth, date_of_birth_is_estimated,
        contact_phone, contact_email,
        student_idcode, ref_id,
        edit, link_secret_code, user, user_links,
        status, merged_into_id, identity_status,
        id, can_send_link_invite, invite_sent_count, invite_max_count,
    } = item ?? {}

    const isArchived = status === STUDENT_STATUS_ARCHIVED
    const inactive = item?.active === 0
    const isUnknownDob = !date_of_birth
    const initials = getInitials(fullname)
    const color = getGroupColor(fullname)
    const patronSaint = getAliasName(item, 'patron_saint')

    const _identity_status = identity_status ?? IDENTITY_STATUS.UNVERIFIED
    const isVerified = _identity_status === IDENTITY_STATUS.VERIFIED

    // "Đã gắn User" = học viên có TÀI KHOẢN CỦA CHÍNH MÌNH (khác StudentUserLink quan hệ cha/mẹ/
    // giám hộ - đó là NGƯỜI KHÁC được cấp quyền xem/quản lý, không phải tài khoản của học viên).
    // BE có 2 nguồn cho việc này (Student.php dòng ~190, comment "Kiểm tra cả legacy students.
    // user_id lẫn student_user_links SELF mới"): field `user` (legacy FK students.user_id, LUÔN có
    // trong response) VÀ `user_links` lọc relationship=SELF (StudentUserLink mới, chỉ BE trả khi
    // edit===true - xem StudentTransformer.php). Trước đó tôi chỉ check user_links (bỏ sót học viên
    // gắn qua legacy user_id, hiện sai "Chưa gắn User") - phải check CẢ 2 mới đúng.
    const selfLink = edit === true ? _.find(user_links, {relationship: 'SELF'}) : undefined
    const linkedUser = user?.id ? user : selfLink?.user
    const isUserLinked = edit === true && !!linkedUser?.id

    const renderCodePill = (label, value, colorClass) => value ? (
        <span
            key={label}
            onClick={() => { copyToClipboard(value); message.info(t('copied')) }}
            className={classNames("px-2 py-0.5 rounded-full background-100 font-mono text-2xs font-semibold cursor-pointer flex items-center gap-1 whitespace-no-wrap", colorClass)}>
            {label}: {value}
            <IoCopyOutline size={9}/>
        </span>
    ) : null

    return (
        <div key={index} className={classNames(
            "p-4 flex flex-col gap-3 border background rounded-2xl hover:shadow-md transition-all duration-300 relative custom-item-render",
            isArchived ? "opacity-60 bg-gray-50 border-color-100" : (isUserLinked ? "border-green-200" : "border-color-100")
        )}>
            <div className={classNames("flex flex-col gap-3", inactive && "opacity-40")}>
                {/* Header: avatar + name + trạng thái gắn User (chỉ admin thấy) */}
                <div className="flex items-start justify-between gap-2">
                    <div className="flex items-center gap-2.5 min-w-0">
                        {avatar ? (
                            <Avatar
                                size={40}
                                src={avatar}
                                className="rounded-full"
                            />
                        ) : (
                            <div
                                style={{width: 40, height: 40, backgroundColor: color, flexShrink: 0}}
                                className="rounded-full flex flex-center">
                                <span className="text-white font-bold text-xs leading-none">{initials}</span>
                            </div>
                        )}
                        <div className="flex flex-col min-w-0">
                            {patronSaint && (
                                <span className="text-xs font-medium text-gray-600 leading-snug truncate">{patronSaint}</span>
                            )}
                            <span className="font-bold text-sm text-color-000 leading-snug truncate">
                                {fullname}
                                {isVerified && (
                                    <Tooltip title={t('identity verified')}>
                                        <RiShieldCheckFill size={13} className="ml-0.5 text-green-500 flex-shrink-0"/>
                                    </Tooltip>
                                )}
                            </span>
                            {isArchived && (
                                <span className="flex items-center gap-1 text-2xs text-color-400 italic">
                                    <MdMerge size={10}/>
                                    {t('archived')}
                                    {merged_into_id && ` · ${t('merged into another record')}`}
                                </span>
                            )}
                        </div>
                    </div>
                    {edit === true && (
                        <div className="flex flex-col items-end gap-1 flex-shrink-0">
                            {isUserLinked ? (
                                <span className="px-2.5 py-1 rounded-full text-2xs font-bold flex items-center gap-1 flex-shrink-0 bg-green-50 text-green-600 whitespace-no-wrap">
                                    <IoCheckmarkCircle size={11}/>
                                    {t('user account linked')}
                                </span>
                            ) : (
                                <span className="px-2.5 py-1 rounded-full text-2xs font-medium flex items-center gap-1 flex-shrink-0 border border-color-200 text-color-400 whitespace-no-wrap">
                                    <IoEllipseOutline size={10}/>
                                    {t('user account not linked')}
                                </span>
                            )}
                            <SendLinkInviteButton
                                studentId={id}
                                canSend={can_send_link_invite}
                                t={t}
                                compact
                                inviteSentCount={invite_sent_count}
                                inviteMaxCount={invite_max_count}
                            />
                        </div>
                    )}
                </div>

                {/* Codes */}
                {(student_idcode || ref_id || (edit === true && link_secret_code) || (isUserLinked && linkedUser?.username)) && (
                    <div className="flex flex-wrap items-center gap-1.5">
                        {student_idcode && (
                            <span
                                onClick={() => { copyToClipboard(student_idcode); message.info(t('copied')) }}
                                className="px-2 py-0.5 rounded-full background-100 font-mono text-2xs font-semibold cursor-pointer flex items-center gap-1 whitespace-no-wrap text-blue-500 hover:text-blue-700">
                                #{student_idcode}
                                <IoCopyOutline size={9}/>
                            </span>
                        )}
                        {renderCodePill(t('Ref'), ref_id, 'text-secondary-500 hover:text-secondary-600')}
                        {edit === true && renderCodePill(t('link code short'), link_secret_code, 'text-indigo-500 hover:text-indigo-700')}
                        {isUserLinked && linkedUser?.username && (
                            <span className="px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-600 font-mono text-2xs font-semibold flex items-center gap-1 whitespace-no-wrap">
                                @{linkedUser.username}
                            </span>
                        )}
                    </div>
                )}

                {/* Footer: giới tính/DOB/phone/email + actions */}
                <div className="flex items-center justify-between gap-2 pt-2.5 border-t border-color-50">
                    <div className="flex flex-col gap-1 min-w-0">
                        {(gender === 1 || gender === 2 || !isUnknownDob) && (
                            <span className="flex items-center gap-1 text-2xs text-color-300 whitespace-no-wrap">
                                {(gender === 1 || gender === 2) && renderGenderBadge(gender, t)}
                                {(gender === 1 || gender === 2) && !isUnknownDob && <GoDotFill size={6} />}
                                {!isUnknownDob && <span className="font-medium">{formatDate(date_of_birth, 'DD/MM/YYYY')}</span>}
                                {date_of_birth_is_estimated && <EstimatedDobTag/>}
                            </span>
                        )}
                        {contact_phone && (
                            <span className="flex items-center gap-1.5 text-2xs text-color-300">
                                <HiPhone size={11} className="flex-shrink-0"/>
                                <span className="truncate">{contact_phone}</span>
                            </span>
                        )}
                        {contact_email && (
                            <span className="flex items-center gap-1.5 text-2xs text-color-300">
                                <MdOutlineEmail size={11} className="flex-shrink-0"/>
                                <span className="truncate">{contact_email}</span>
                            </span>
                        )}
                    </div>
                    <div className="flex items-center gap-1.5 flex-shrink-0">
                        <button
                            type="button"
                            onClick={() => handleAction(StudentActionTypes.STUDENT_DETAIL, item)}
                            className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-50 hover:bg-primary-100 text-primary-600 font-semibold text-xs whitespace-no-wrap">
                            {t('detail')}
                            <BsChevronRight size={11}/>
                        </button>
                        <div className="p-1.5 hover:background-200 rounded-lg cursor-pointer">
                            {renderContextMenu(item)}
                        </div>
                    </div>
                </div>
            </div>
            {inactive && (
                <span className="w-fit flex items-center justify-end gap-1 flex-shrink-0 px-3 py-0.5 border border-orange-300 rounded-full">
                    <span className="w-1.5 h-1.5 bg-orange-400 rounded-full" />
                    <span className="font-medium text-2xs text-orange-400">
                        {t('temporarily inactive')}
                    </span>
                </span>
            )}
        </div>
    )
}

// Cột "THAO TÁC" của bảng - TÁCH RIÊNG 2 hàng (bạn báo lệch nhau): hàng trên là nút "Gửi email mời
// liên kết" (chỉ hiện khi đủ điều kiện), hàng dưới là mắt/bánh răng - LUÔN cùng 1 vị trí cố định
// (canh phải) ở MỌI dòng bất kể dòng đó có nút mời hay không, khác trước đây gộp chung 1 hàng nên
// dòng có nút mời rộng hơn hẳn dòng không có, nhìn lệch. Trên mobile (isSm) nút mời rút về icon-only
// (iconOnly) để không đẩy lệch/tràn dòng - cần đọc LayoutContext nên tách thành component riêng
// (renderStudentTableRow là hàm thường, không gọi hook được).
const ActionsCell = ({item, id, can_send_link_invite, invite_sent_count, invite_max_count, t, handleAction, renderContextMenu}) => {
    const {isSm} = useContext(LayoutContext)

    return (
        <div className="flex flex-col items-end gap-1.5">
            <SendLinkInviteButton
                studentId={id}
                canSend={can_send_link_invite}
                t={t}
                compact
                iconOnly={isSm}
                inviteSentCount={invite_sent_count}
                inviteMaxCount={invite_max_count}
            />
            <div className="flex items-center justify-end gap-2">
                <button
                    type="button"
                    onClick={() => handleAction(StudentActionTypes.STUDENT_DETAIL, item)}
                    style={{width: 28, height: 28}}
                    className="flex flex-center rounded-full border border-color-200 hover:border-primary hover:background-100 text-color-400 hover:text-primary">
                    <BsEyeFill size={13}/>
                </button>
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

export const renderStudentTableRow = ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}) => (item, index) => {
    const {
        avatar,
        fullname, gender,
        date_of_birth, date_of_birth_is_estimated,
        contact_phone, contact_email,
        student_idcode, ref_id, link_secret_code,
        status, merged_into_id,
        identity_status, edit,
        user, user_links,
        id, can_send_link_invite, invite_sent_count, invite_max_count,
    } = item ?? {}

    const isArchived = status === STUDENT_STATUS_ARCHIVED
    const inactive = item?.active === 0
    const isUnknownDob = !date_of_birth
    const initials = getInitials(fullname)
    const color = getGroupColor(fullname)
    const patronSaint = getAliasName(item, 'patron_saint')

    const _identity_status = identity_status ?? IDENTITY_STATUS.UNVERIFIED
    const isVerified = _identity_status === IDENTITY_STATUS.VERIFIED

    // "Đã gắn User" - cùng cách renderStudentCardItem đang tính (check CẢ 2 nguồn: user legacy FK
    // students.user_id VÀ user_links relationship=SELF mới) - bảng này trước đây THIẾU hẳn chỉ báo
    // này nên không phân biệt được học viên nào đã có tài khoản liên kết (bạn báo).
    const selfLink = edit === true ? _.find(user_links, {relationship: 'SELF'}) : undefined
    const linkedUser = user?.id ? user : selfLink?.user
    const isUserLinked = edit === true && !!linkedUser?.id

    return (
        <tr key={index} className={classNames(
            "border-t border-color-50 background hover:background-50 transition-colors",
            isArchived && "opacity-60 bg-gray-50"
        )}>
            <td className="px-3 py-2.5 ">
                <div className={classNames("flex items-center gap-2.5 min-w-0", inactive && "opacity-40")}>
                    {(avatar || user?.avatar ) ? (
                        <Avatar
                            size={36}
                            src={avatar || user?.avatar}
                            className="rounded-full"
                        />
                    ) : (
                        <div
                            style={{width: 36, height: 36, backgroundColor: color, flexShrink: 0}}
                            className="rounded-full flex flex-center">
                            <span className="text-white font-bold text-xs leading-none">{initials}</span>
                        </div>
                    )}
                    <div className="flex flex-col flex-1 min-w-0">
                        {patronSaint && (
                            <span className="font-medium text-xs text-gray-600 leading-snug truncate">{patronSaint}</span>
                        )}
                        <span
                            onClick={() => handleAction(StudentActionTypes.STUDENT_DETAIL, item)}
                            className="font-semibold text-sm text-color-000 hover:text-primary leading-snug truncate cursor-pointer">
                            {fullname}
                            {isVerified && (
                                <Tooltip title={t('identity verified')}>
                                    <RiShieldCheckFill size={13} className="ml-0.5 text-green-500 flex-shrink-0"/>
                                </Tooltip>
                            )}
                        </span>
                        {/* Giới tính + ngày sinh gộp vào cột Học viên để nhận dạng nhanh */}
                        {(gender === 1 || gender === 2 || !isUnknownDob) && (
                            <div className="mt-0.5 flex items-center gap-1.5 flex-wrap">
                                {renderGenderBadge(gender, t)}
                                {!isUnknownDob && (
                                    <span className="flex items-center gap-1 text-2xs text-color-300 whitespace-no-wrap">
                                        {formatDate(date_of_birth, 'DD/MM/YYYY')}
                                        {date_of_birth_is_estimated && <EstimatedDobTag/>}
                                    </span>
                                )}
                            </div>
                        )}
                        {isArchived && (
                            <span className="flex items-center gap-1 text-2xs text-color-400 italic">
                                <MdMerge size={10}/>
                                {t('archived')}
                                {merged_into_id && ` · ${t('merged into another record')}`}
                            </span>
                        )}
                    </div>
                </div>
                {/* Badge "Tạm ngưng hoạt động" - đặt ngoài div opacity-40 để không bị mờ theo */}
                {inactive && (
                    <div className="flex justify-end">
                        <span className="mt-1 w-fit flex items-center gap-1 flex-shrink-0 px-1.5 py-0.5 border border-orange-300 bg-orange-50 rounded-full whitespace-no-wrap">
                            <span className="w-1.5 h-1.5 bg-orange-400 rounded-full flex-shrink-0"/>
                            <span className="font-medium text-2xs text-orange-500 leading-tight">
                                {t('temporarily inactive')}
                            </span>
                        </span>
                    </div>
                )}
            </td>
            <td className={classNames("px-3 py-2.5", inactive && "opacity-40")}>
                <div className="flex flex-col gap-0.5 font-mono text-xs">
                    {student_idcode && (
                        <span
                            onClick={() => { copyToClipboard(student_idcode); message.info(t('copied')) }}
                            className="text-blue-500 hover:text-blue-700 cursor-pointer flex items-center gap-1 whitespace-no-wrap">
                            #{student_idcode}
                            <IoCopyOutline size={9}/>
                        </span>
                    )}

                    {edit === true && link_secret_code && (
                        <span
                            onClick={() => { copyToClipboard(link_secret_code); message.info(t('copied')) }}
                            className="text-xs text-secondary hover:text-secondary-600 cursor-pointer flex items-center gap-1 whitespace-no-wrap">
                            {`${t('link code short')}:`}
                            {link_secret_code}
                            <IoCopyOutline size={9}/>
                        </span>
                    )}
                    {/* Mã tham chiếu: chỉ để xem, không cần copy - bỏ icon + click, chữ mờ */}
                    {ref_id && (
                        <span className="text-2xs text-color-300 whitespace-no-wrap">
                            {`Ref: ${ref_id}`}
                        </span>
                    )}
                    {/* Đã gắn tài khoản User - CHỈ chỉ báo còn thiếu ở bảng này (renderStudentCardItem
                        đã có), giúp phân biệt ngay học viên nào đã có người liên kết tài khoản. */}
                    {isUserLinked && linkedUser?.username && (
                        <span className="text-indigo-500 flex items-center gap-1 whitespace-no-wrap">
                            <IoCheckmarkCircle size={10} className="text-indigo-400 flex-shrink-0"/>
                            @{linkedUser.username}
                        </span>
                    )}
                </div>
            </td>
            <td className={classNames("px-3 py-2.5", inactive && "opacity-40")}>
                <div className="flex flex-col gap-0.5 text-xs text-color-300">
                    {contact_phone && (
                        <span className="flex items-center gap-1 whitespace-no-wrap">
                            <HiPhone size={10} className="flex-shrink-0"/>{contact_phone}
                        </span>
                    )}
                    {contact_email && (
                        <span className="flex items-center gap-1 truncate">
                            <HiOutlineMail size={11} className="flex-shrink-0"/>{contact_email}
                        </span>
                    )}
                </div>
            </td>
            <td className="px-3 py-2.5">
                <ActionsCell
                    item={item}
                    id={id}
                    can_send_link_invite={can_send_link_invite}
                    invite_sent_count={invite_sent_count}
                    invite_max_count={invite_max_count}
                    t={t}
                    handleAction={handleAction}
                    renderContextMenu={renderContextMenu}
                />
            </td>
        </tr>
    )
}